import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { MenuItem, MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from 'src/app/modules/entities/user';
import { UserService } from 'src/app/modules/services/user.service';
import { url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-register-1',
  templateUrl: './user-register.component.html',
  styleUrls: ['./user-register.component.css'],
})
export class UserRegisterComponent implements OnInit {

  constructor(private router: Router, private fb: FormBuilder, private userService: UserService, private messageService: MessageService, 
    private cookies: CookieService, @Inject(PLATFORM_ID) private platformId: Object) {
    this.userForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('[0-9]+')], 
        UsernameValidator.createValidator(this.userService, this.messageService)],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(20)]]
    });
  }
  
  userForm: FormGroup;
  newUser: boolean = true;
  steps: MenuItem[] | undefined;
  contactNumber: string = '';

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.contactNumber = this.cookies.get('contact').replaceAll("\"", "");
    }
    this.steps = [
        {
            label: 'Contacto',
            routerLink: '/' + url['registro-1']
        },
        {
            label: 'Descripción',
            routerLink: '/' + url['registro-2']
        },
        {
            label: 'Multimedia',
            routerLink: '/' + url['carga-imagenes']
        }
    ];
  }

  contactUs() {
    let contactUrl = 'https://api.whatsapp.com/send?phone=' + this.contactNumber;
    window.open(contactUrl);
  }

  navigateToPersonRegistration() {
    let user: User = {
      userName: this.userForm.value['username'],
      password: this.userForm.value['password'],
      active: 1,
      registrationDate: new Date(),
      lastLogin: new Date(),
      role: 'cliente'
    }
    let navigationExtra: NavigationExtras = {
      state: { user: user }
    }
    this.router.navigate([url['registro-2']], navigationExtra);
  }
}

class UsernameValidator {
  static createValidator(userService: UserService, messageService: MessageService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return userService.checkUser(control.value).pipe(
        map((response) => {
          let exists: boolean = Boolean(response.data);
          if (exists) {
            messageService.clear();
            messageService.add({
              key: 'user',
              severity: 'error',
              detail: 'Este número ya se encuentra registrado'
            });
          } else {
            messageService.clear();
          }
          return exists ? { usernameAlreadyExists: true } : null
        }
        )  
      );
    };
  }
}